import React from 'react';
import {
  FaUsers,
  FaBook,
  FaGraduationCap,
  FaCheck,
  FaUniversity,
  FaLightbulb
} from 'react-icons/fa';

const AboutUs = () => {

  const programs = [
    "Computer Science & Engineering",
    "Electrical & Electronic Engineering",
    "Textile Engineering",
    "Civil Engineering",
    "Mechanical Engineering"
  ];

  const features = [
    "Excellent spacious campus with modern facilities & state-of-the-art design",
    "Highly qualified full-time & adjunct faculty from KU, KUET, RUET, RU",
    "Sufficient well-equipped labs & workshops for practical learning",
    "Air-conditioned rich library with free book issuing facility",
    "Air-conditioned labs & classrooms with multimedia system",
    "Interactive teaching method with audio-visual system",
    "Free high-speed WiFi facility",
    "Lab & workshop open for practice during office hours",
    "Separate hostel facilities for male & female students",
    "Industrial visits, workshops, seminars & conferences",
    "Sports & cultural activities",
    "Completely politics-free campus",
    "Very reasonable tuition fees structure and affordable cost",
    "Scholarship & tuition waiver based on SSC/HSC/Diploma result",
    "Various co-curricular activities",
    "Several clubs & organizations for skill development",
    "Job placement cell & industrial linkage to ensure campus placement",
    "English language club & mandatory English practice",
    "Excellent cafeteria & students lobby with indoor games, TV & Free WiFi",
    "All-time electricity supply with 2 standby generators",
    "Secure campus with 100+ CCTV cameras & 24/7 security guard",
    "Well maintained rules & regulations"
  ];

  return (
    <div className="bg-gray-50">

      {/* Hero Section */}
      <div className="h-80 bg-primary flex flex-col justify-center items-center text-white text-center px-4">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          Imperial College of Engineering
        </h1>
        <p className="text-lg md:text-xl">
          Rajshahi University Affiliated Engineering College (College Code: 385)
        </p>
      </div>

      <div className="container mx-auto px-4 md:px-12 py-16">

        {/* Affiliation Section */}
        <div className="bg-white shadow-xl rounded-2xl p-8 mb-16">

          <div className="text-center mb-8">
            <FaUniversity className="text-primary text-4xl mx-auto mb-3" />
            <h2 className="text-3xl font-bold text-primary">
              Our Affiliation & Establishment
            </h2>
          </div>

          <p className="text-gray-700 mb-4 leading-relaxed text-justify">
            Imperial College of Engineering (ICE) received approval for affiliation 
            on <strong>18th October 2017</strong> from Rajshahi University. 
            The governing body established ICE to spread quality engineering education 
            among students of southern Bangladesh.
          </p>

          <p className="text-gray-700 mb-4 leading-relaxed text-justify">
            ICE is located in the industrial area of Khalishpur, Khulna Division, 
            aiming to help students fulfill their dream of becoming successful engineers. 
            As education quality is verified and evaluated by a public university 
            and certification is provided by them, the degree holds strong academic value 
            compared to many other private universities in Khulna.
          </p>

          <p className="text-gray-700 leading-relaxed text-justify">
            ICE started with Computer Science & Engineering, Electrical & Electronic Engineering, 
            and Civil Engineering in the 2017–2018 session and expanded to five disciplines 
            from the 2018–2019 session onward.
          </p>

        </div>

        {/* Programs Section */}
        <div className="mb-16">

          <div className="text-center mb-12">
            <FaGraduationCap className="text-primary text-4xl mx-auto mb-3" />
            <h2 className="text-3xl font-bold text-primary">
              Bachelor of Science Programs
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {programs.map((program, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition transform hover:-translate-y-2"
              >
                <h3 className="font-bold text-xl mb-2">{program}</h3>
                <p className="text-gray-600">
                  4-year program affiliated with Rajshahi University.
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Governing Body */}
        <div className="bg-white shadow-xl rounded-2xl p-8 mb-16">

          <div className="text-center mb-8">
            <FaUsers className="text-primary text-4xl mx-auto mb-3" />
            <h2 className="text-3xl font-bold text-primary">
              Governing Body
            </h2>
          </div>

          <p className="text-gray-700 leading-relaxed text-center max-w-3xl mx-auto">
            Imperial College of Engineering is directed by a group of experienced engineers 
            and mentors from reputed public universities like KU, KUET, RUET, and Rajshahi University.
          </p>
        </div>

        {/* Special Features */}
        <div className="mb-16">

          <div className="text-center mb-12">
            <FaBook className="text-primary text-4xl mx-auto mb-3" />
            <h2 className="text-3xl font-bold text-primary">
              Special Features
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl shadow-md p-5 flex items-start gap-3 hover:shadow-xl transition"
              >
                <FaCheck className="text-green-500 mt-1" />
                <p className="text-gray-700">{feature}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Vision Section */}
        <div className="bg-primary text-white rounded-2xl p-12 text-center">
          <FaLightbulb className="text-4xl mb-4 mx-auto" />
          <h2 className="text-3xl font-bold mb-4">
            Our Vision
          </h2>
          <p className="max-w-3xl mx-auto leading-relaxed">
            To provide international quality public university degrees and produce 
            skilled, qualified, and ethical engineers who contribute to the nation 
            and global industry.
          </p>
        </div>

      </div>
    </div>
  );
};

export default AboutUs;